import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=5e61f625&scoped=true"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=5e61f625&prod&scoped=true&lang=scss"
import style1 from "./ItemInfo.vue?vue&type=style&index=1&id=5e61f625&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e61f625",
  null
  
)

export default component.exports